import { SelectData } from '@occc-app/design-system';
import { SurveysFormValues } from '@occc-app/routes/Audience/types';
import { Audience_Survey_Response_Operator } from '@occc/graphql';

import { AudienceSurveyResponseSliderOperator, MemberResponded } from './types';

export const titleByMemberResponded: Record<MemberResponded, string> = {
  responded: 'Responded to',
  'not-responded': 'Not responded to',
};

export const respondedOptions: { title: string; value: MemberResponded }[] = [
  {
    title: titleByMemberResponded['responded'],
    value: 'responded',
  },
  {
    title: titleByMemberResponded['not-responded'],
    value: 'not-responded',
  },
];

export const optionTitleBySurveyResponseOperator: Record<
  AudienceSurveyResponseSliderOperator,
  string
> = {
  'is-equal-to': 'Exactly',
  'is-greater-than': 'More than',
  'is-greater-than-or-equal': 'More or exactly',
  'is-less-than': 'Less than',
  'is-less-than-or-equal': 'Less or exactly',
  'is-between': 'Between (and including)',
};

const sliderOperators: AudienceSurveyResponseSliderOperator[] = [
  'is-between',
  'is-equal-to',
  'is-greater-than',
  'is-greater-than-or-equal',
  'is-less-than',
  'is-less-than-or-equal',
];

export const sliderOperatorOptions: SelectData[] = sliderOperators.map((value) => ({
  label: optionTitleBySurveyResponseOperator[value],
  value,
}));

export const surveysInitialFormValues: SurveysFormValues = {
  respondedStatus: 'responded',
  surveyAnswers: [],
  sliderOperator: 'is-equal-to',
  locations: [],
};

export const inputOperatorBySliderOperator: Record<
  AudienceSurveyResponseSliderOperator,
  Audience_Survey_Response_Operator
> = {
  'is-equal-to': Audience_Survey_Response_Operator.IsEqualTo,
  'is-greater-than': Audience_Survey_Response_Operator.IsGreaterThan,
  'is-greater-than-or-equal': Audience_Survey_Response_Operator.IsGreaterThanOrEqualTo,
  'is-less-than': Audience_Survey_Response_Operator.IsLessThan,
  'is-less-than-or-equal': Audience_Survey_Response_Operator.IsLessThanOrEqualTo,
  'is-between': Audience_Survey_Response_Operator.IsBetween,
};

export const sliderOperatorByInputOperator: Record<
  Audience_Survey_Response_Operator,
  AudienceSurveyResponseSliderOperator | null
> = {
  [Audience_Survey_Response_Operator.IsEqualTo]: 'is-equal-to',
  [Audience_Survey_Response_Operator.IsGreaterThan]: 'is-greater-than',
  [Audience_Survey_Response_Operator.IsBetween]: 'is-between',
  [Audience_Survey_Response_Operator.IsLessThan]: 'is-less-than',
  [Audience_Survey_Response_Operator.IsIn]: null,
  [Audience_Survey_Response_Operator.IsNotIn]: null,
  [Audience_Survey_Response_Operator.IsNotEqualTo]: null,
  [Audience_Survey_Response_Operator.IsGreaterThanOrEqualTo]: 'is-greater-than-or-equal',
  [Audience_Survey_Response_Operator.IsLessThanOrEqualTo]: 'is-less-than-or-equal',
};

export const titleBySliderOperator: Record<
  Exclude<AudienceSurveyResponseSliderOperator, 'is-between'>,
  string
> = {
  'is-equal-to': 'Exactly',
  'is-greater-than': 'More than',
  'is-less-than': 'Less than',
  'is-greater-than-or-equal': 'More or exactly',
  'is-less-than-or-equal': 'Less or exactly',
};
